class ProductCardTemplate {
  constructor() {

  }

  static newCardTemplate(product, colorStatus) {
    const options = this.getOptions(product.options, product.variants);

      const cardHTML = `
        <product-card data-selected-swatch="${product.handle}" data-json-script-id="${product.handle}-json">
          <script id="${product.handle}-json" type="application/json"></script>
          <div class="card-wrapper" itemprop="item" itemscope itemtype="https://schema.org/Product">
            <meta itemprop="url" content="/products/${product.handle}">
            <div class="card-image-wrapper">
              <a href="/products/${product.handle}" class="full-unstyled-link">
                <span class="visually-hidden">${product.title}</span>
                <div class="card card--product card--outline" tabindex="-1">
                  <div class="card__inner">
                    <div>
                      <div class="media media--transparent media--hover-effect" style="padding-bottom: 133%;">
                        <img srcset="${product.images[0]} 533w" src="${product.images[0]}" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="PLP-EXCLUSIVE" loading="lazy" class="motion-reduce featured-card-image">
                        ${product.images[1] ? `
                            <img srcset="${product.images[1]} 720w," src="${product.images[1]}" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="PLP-EXCLUSIVE" loading="lazy" class="motion-reduce hover-secondary-image">
                          `: ""}
                      </div>
                    </div>
                    <div class="card__badge"></div>
                  </div>
                </div>
              </a>
              ${this.quickAddTemplate(options, product.handle)}
            </div>
            <div class="card-infos">
              <div class="card-information">
                <div class="card-information__wrapper">
                  <span class="card-information__text h5">
                  ${product.title}
                  </span>
                  ${this.priceInformation(product)}
                </div>
              </div>
              ${this.colorSwatchTemplate(options, product.tags, product.handle)}
              ${this.mobileQuickAddTemplate(options, product.handle)}
            </div>
          </div>
        </product-card>
      `;

      return `<div class="grid__item">${cardHTML}</div>`;
  }

  static checkVisible(product, fitStatus, colorStatus) {
    var colorFlag = false;
    var fitFlag = false;
    if(product.tags) {
      for(var i = 0; i < product.tags.length; i++) {
        colorFlag = false;
        const tag = product.tags[i];

        if(tag.includes("color_")) {
          if(tag.toLowerCase().includes(colorStatus.toLowerCase())) {
            colorFlag = true;
            break;
          }
        }
      }
      
      for(var i = 0; i < product.tags.length; i++) {
        fitFlag = false;
        const tag = product.tags[i];

        if(tag.includes("fit_")) {
          if(tag.toLowerCase().includes(fitStatus.toLowerCase())) {
            fitFlag = true;
            break;
          }
        }
      }
    }
    return colorFlag && fitFlag;
  }

  static filterProducts(products, fitStatus, colorStatus) {
    let filteredProducts = [];
    products.forEach(product => {
      if(this.checkVisible(product, fitStatus, colorStatus)) {
        filteredProducts.push(product);
      }
    });
    return filteredProducts;
  }
  
  static checkStepItem(products, step, dataTag) {
    let filteredProducts = [];
  	switch (step) {
      case 'fit':
        products.forEach(product => {
          var showFlag = false;
          if(product.tags) {
            for(var i = 0; i < product.tags.length; i++) {
              showFlag = false;
              const tag = product.tags[i];

              if(tag.includes("fit_")) {
                if(tag.toLowerCase().includes(dataTag.toLowerCase())) {
                  showFlag = true;
                  break;
                }
              }
            }
          }
          
          if(showFlag) filteredProducts.push(product);
        });
        break;
      case 'level':
        products.forEach(product => {
          var showFlag = false;
          if(product.tags) {
            for(var i = 0; i < product.tags.length; i++) {
              showFlag = false;
              const tag = product.tags[i];

              if(tag.includes("stretchpercent_")) {
                const level = dataTag == 'low' ? '26-35' : dataTag == 'medium' ? '36-49' : '50';
                if(tag.toLowerCase().includes(level)) {
                  showFlag = true;
                  break;
                }
              }
            }
          }
          
          if(showFlag) filteredProducts.push(product);
        });
        break;
      case 'color':
        products.forEach(product => {
          var showFlag = false;
          if(product.tags) {
            for(var i = 0; i < product.tags.length; i++) {
              showFlag = false;
              const tag = product.tags[i];

              if(tag.includes("color_")) {
                if(tag.toLowerCase().includes(dataTag.toLowerCase())) {
                  showFlag = true;
                  break;
                }
              }
            }
          }
          
          if(showFlag) filteredProducts.push(product);
        });
        
        break;
      default:
        console.log(`Sorry, we are out of ${expr}.`);
    }
    
    return filteredProducts;
  }

  static getOptions(options, variants) {
    let optionArray = [];
    options.map((option, optionIndex) => {
      optionArray.push({
        name: option,
        position: optionIndex + 1,
        values: []
      });
    });
    variants.map(variant => {
      for(var i = 0; i < optionArray.length; i++) {
        if(!optionArray[i].values.includes(variant['option' + (i + 1)])) {
          optionArray[i].values.push(variant['option' + (i + 1)]);
        }
      }
    });

    return optionArray;
  }

  static quickAddTemplate(options, prodHandle) {
    const includesColor = options.find((option) => option.name === "Color");
    const quickHTML = includesColor ? `
      <quick-add data-selected-swatch="${prodHandle}">
        <div class="quick-add-btn">
          + Quick Add
          <div class="quick-add-options__wrapper">
            ${options.map((option) => {
              return option.name !== "Color" ? `
                <div class="quick-add-option">
                  <div class="quick-add-option-name">${option.name}:</div>
                  <div data-option-position="option${option.position}" data-option-name="${option.name}" class="quick-add-option-values">
                    ${option.values.map(value => {
                      return `<span class="quick-add-option-value">${value}</span>`
                    }).join("")}
                  </div>
                </div>
              `: "";
            }).join("")}
          </div>
        </div>
      </quick-add>
    `: "";

    return quickHTML;
  }

  static priceInformation(product) {
    const options = this.getOptions(product.options, product.variants);
    const productColor = options.find((option) => option.name === "Color");
    const hasColorOption = productColor ? true : false;
    const color = productColor ? productColor.values[0] : null;

    var compare_at_price, price;
    product.variants.forEach(variant => {
      var variantComparePrice = (parseFloat(variant.compare_at_price) / 100);
      var variantPrice = (parseFloat(variant.price) / 100);

      if(!compare_at_price || (variantComparePrice && variantComparePrice < compare_at_price)) {
        compare_at_price = variantComparePrice;
      }
      if(!price || (variantPrice && variantPrice < price)) {
        price = variantPrice;
      }
    });
    const prodAvailable = product.variants.find((variant) => variant.available === true) ? true : false;

    const priceHTML = `
      <div class="price
        ${prodAvailable === false ? " price--sold-out" : ""}
        ${compare_at_price > price ? " price--on-sale" : ""}">
        <dl>
          <div class="price__regular">
            <dt>
              <span class="visually-hidden visually-hidden--inline">Regular Price</span>
            </dt>
            <dd>
              <span class="price-item price-item--regular
                ${hasColorOption && color ? " border-right" : ""} product-card-price">
                $${price}
              </span>
              ${hasColorOption && color ? `<span class="product-color">${color}</span>`: ""}
            </dd>
          </div>
          <div class="price__sale">
            <dd class="price__compare product-card">
              <s class="price-item price-item--regular">
                $${compare_at_price}
                ${hasColorOption && color ? `
                   | <span class="product-color">${color}</span>
                `: ""}
              </s>
            </dd>
            <dt>
              <span class="visually-hidden visually-hidden--inline">Sale Price</span>
            </dt>
            <dd>
              <span class="price-item product-card price-item--sale">
                $${price}
              </span>
              <span class="price-item old-price">
                $${compare_at_price}
              </span>
              ${hasColorOption && color ? `
                <span class="product-color">${color}</span>
              `: ""}
            </dd>
          </div>
        </dl>
      </div>
    `;

    return priceHTML;
  }

  static colorSwatchTemplate(options, tags, prodHandle) {
    const includesColor = options.find((option) => option.name === "Color");
    const swatchHTML = includesColor ? `
      <product-swatch>
        <div class="product-swatches">
          <div data-color="${includesColor.values[0]}" data-handle="${prodHandle}" class="product-swatch swatch-selected">
            <span class="swatch-color ${this.handleize(includesColor.values[0])}"></span>
          </div>
          ${tags.map(tag => {
            if(tag.includes("related_")) {
              const handleAndColorArr = tag.split("related_")[1].split(":");
              const varHandle = handleAndColorArr[0];
              const varColor = handleAndColorArr[1];
              return `
                <div data-color="${varColor.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}" data-handle="${varHandle}" class="product-swatch">
                  <span type="radio" class="swatch-color ${this.handleize(varColor)}"></span>
                </div>
              `;
            } else {return ""}
          }).join("")}
        </div>
      </product-swatch>
    `: "";

    return swatchHTML;
  }

  static mobileQuickAddTemplate(options, prodHandle) {
    const quickaddHTML = `
      <mobile-quick-add data-selected-swatch="${prodHandle}">
        <div class="mobile-quick-add-options__wrapper">
          ${options.map(option => {
            return option.name !== "Color" ? `
              <div class="quick-add-option">
                <div class="quick-add-option-name">${option.name}:</div>
                <div data-option-name="${option.name}" data-option-position="option${option.position}" class="quick-add-option-values">
                  ${option.values.map(value => {
                    return `<span class="quick-add-option-value">${value}</span>`
                  }).join("")}
                </div>
              </div>
            `: "";
          }).join("")}
        </div>
        <button type="button" class="mobile-quick-add-btn">
          Quick Add
        </button>
      </mobile-quick-add>
    `;

    return quickaddHTML;
  }

  /* from https://gist.github.com/tyteen4a03/3420a9e121d13b091343 */
  static handleize(str) {
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }

    return str
  }
}

let quizStatus = {
  fit: '',
  level: '',
  color: '',
  result: false
}
const quizResultCollection = document.querySelector(".main-quiz").getAttribute("data-collection");
let quizProducts;
let renderedResults = [];
getQuizProducts();

async function getQuizProducts(){
  await fetch(`${quizResultCollection}/?view=quiz-filter`).then(response => response.text()).then(data => {
    quizProducts = JSON.parse(data).products
  });
  goToStep('fit');
}

function availableStep(target_step) {
  if(target_step == 'color') {
    if(quizStatus.fit == '' || quizStatus.level == '') return false;
  } else if(target_step == 'level') {
    if(quizStatus.fit == '') return false;
  } else if(target_step == 'result') {
    if(quizStatus.fit == '' || quizStatus.level == '' || quizStatus.color == '') return false;
  }
  return true;
}

function goToStep(target_step) {
  if(!availableStep(target_step)) return;

  if(target_step == 'color') {
    quizStatus.result = false;
    if(document.querySelector(".main-quiz .quiz-result")){
      document.querySelector(".main-quiz .quiz-result").innerHTML = '';
    }
    
    let stepTags = [];
    const tagElements = document.querySelectorAll(".main-quiz .tab-content.color-content .choose-item");
    if(tagElements.length) {
      tagElements.forEach(item => {
      	stepTags.push(item.getAttribute('data-tag'));
      });
    }
    
    checkStatus(renderedResults['level'][quizStatus.level], 'color', stepTags);
  } else if(target_step == 'level') {
    quizStatus.result = false;
    if(document.querySelector(".main-quiz .quiz-result")){
      document.querySelector(".main-quiz .quiz-result").innerHTML = '';
    }
    quizStatus.color = '';
    if(document.querySelector(".main-quiz .tab-content.color-content .choose-item.active")) {
      document.querySelector(".main-quiz .tab-content.color-content .choose-item.active").classList.remove("active");
    }
    
    let stepTags = [];
    const tagElements = document.querySelectorAll(".main-quiz .tab-content.level-content .choose-item");
    if(tagElements.length) {
      tagElements.forEach(item => {
      	stepTags.push(item.getAttribute('data-tag'));
      });
    }
    
    checkStatus(renderedResults['fit'][quizStatus.fit], 'level', stepTags);
  } else if(target_step == 'fit') {
    quizStatus.result = false;
    if(document.querySelector(".main-quiz .quiz-result")){
      document.querySelector(".main-quiz .quiz-result").innerHTML = '';
    }
    quizStatus.color = '';
    if(document.querySelector(".main-quiz .tab-content.color-content .choose-item.active")) {
      document.querySelector(".main-quiz .tab-content.color-content .choose-item.active").classList.remove("active");
    }
    quizStatus.level = '';
    if(document.querySelector(".main-quiz .tab-content.level-content .choose-item.active")) {
      document.querySelector(".main-quiz .tab-content.level-content .choose-item.active").classList.remove("active");
    }
    
    let stepTags = [];
    const tagElements = document.querySelectorAll(".main-quiz .tab-content.fit-content .choose-item");
    if(tagElements.length) {
      tagElements.forEach(item => {
      	stepTags.push(item.getAttribute('data-tag'));
      });
    }
    
    checkStatus(quizProducts, 'fit', stepTags);
  }

  if(target_step == 'result') {
    if(document.querySelector(".main-quiz .result-inner .color-item.active")) {
      document.querySelector(".main-quiz .result-inner .color-item.active").classList.remove('active');
    }
    if(document.querySelector(".main-quiz .result-inner .color-item[data-tag='" + quizStatus.color + "']")) {
      document.querySelector(".main-quiz .result-inner .color-item[data-tag='" + quizStatus.color + "']").classList.add('active'); 
    }
    const tagElements = document.querySelectorAll(`.main-quiz .tab-content.${target_step}-content .color-item`);
    if(tagElements.length) {
      tagElements.forEach(item => {
        if(renderedResults['color'][item.getAttribute('data-tag')].length > 0) {
          item.classList.remove("disabled");
        } else {
          item.classList.add("disabled");
        }
      });
    }
    renderResult();
  } else {
    if(document.querySelector('.main-quiz .quiz-tab .tab-header.active')) {
      document.querySelector('.main-quiz .quiz-tab .tab-header.active').classList.remove('active');
    }
    if(document.querySelector(".main-quiz .quiz-tab .tab-header[data-target='" + target_step + "']")) {
      document.querySelector(".main-quiz .quiz-tab .tab-header[data-target='" + target_step + "']").classList.add('active'); 
    }
  }
  if(document.querySelector('.main-quiz .tab-content.active')) {
    document.querySelector('.main-quiz .tab-content.active').classList.remove('active'); 
  }
  if(document.querySelector(".main-quiz .tab-content." + target_step + "-content")) {
    document.querySelector(".main-quiz .tab-content." + target_step + "-content").classList.add('active'); 
  }
}

function checkStatus(productsList, step, tags) {
  let tagStatus = [];
  tags.forEach(tag => {
  	const taggedProducts = ProductCardTemplate.checkStepItem(productsList, step, tag);
    tagStatus[tag] = taggedProducts;
  });
  
  const tagElements = document.querySelectorAll(`.main-quiz .tab-content.${step}-content .choose-item`);
  if(tagElements.length) {
    tagElements.forEach(item => {
      if(tagStatus[item.getAttribute('data-tag')].length > 0) {
        item.classList.remove("disabled");
      } else {
        item.classList.add("disabled");
      }
    });
  }
  
  renderedResults[step] = tagStatus;
}

async function renderResult() {
  if(quizStatus.fit == '' || quizStatus.level == '' || quizStatus.color == '') return false;

  document.querySelector(".main-quiz .result-inner .quiz-result").innerHTML = '';
  document.querySelector(".main-quiz .result-inner .quiz-result-wrapper").classList.add("loading");

  let filteredProductsData = renderedResults['color'][quizStatus.color];
  if(filteredProductsData.length) {
    document.querySelector(".main-quiz .result-inner .quiz-result").classList.remove("empty");
    document.querySelector(".main-quiz .result-inner .quiz-result").innerHTML = filteredProductsData.map((prod) => ProductCardTemplate.newCardTemplate(prod, quizStatus.color)).join("");
  } else {
    document.querySelector(".main-quiz .result-inner .quiz-result").classList.add("empty");
    document.querySelector(".main-quiz .result-inner .quiz-result").innerHTML = '<p class="empty-result">No products match the filter.</p>';
  }
  document.querySelector(".main-quiz .result-inner .quiz-result-wrapper").classList.remove("loading");
}

document.querySelectorAll(".main-quiz .quiz-tab .tab-header").forEach(tabHeader => {
  tabHeader.addEventListener('click', function(){
    goToStep(tabHeader.getAttribute('data-target'));
  });
});

document.querySelectorAll(".main-quiz .tab-content .tab-items .choose-item img").forEach(tabItem => {
  tabItem.addEventListener('click', function(){
    if(!tabItem.parentNode.classList.contains('disabled')) {
      quizStatus[tabItem.parentNode.getAttribute('data-type')] = tabItem.parentNode.getAttribute('data-tag');
      if(tabItem.parentNode.parentNode.querySelector(".choose-item.active")) {
        tabItem.parentNode.parentNode.querySelector(".choose-item.active").classList.remove('active');
      }
      tabItem.parentNode.classList.add('active');
      goToStep(tabItem.parentNode.getAttribute('data-target'));
    }
  });
});

document.querySelectorAll(".main-quiz .result-inner .color-item").forEach(colorItem => {
  colorItem.addEventListener('click', function(){
    if(!colorItem.classList.contains('disabled')) {
      quizStatus.color = colorItem.getAttribute('data-tag');
      if(colorItem.parentNode.querySelector(".color-item.active")) {
        colorItem.parentNode.querySelector(".color-item.active").classList.remove('active');
      }
      colorItem.classList.add('active');
      renderResult();
    }
  });
});